import type { IconType } from "react-icons";
import { FaInfoCircle, FaPaperPlane, FaTasks, FaUserCheck, FaUserTie } from "react-icons/fa";
import { defineWizardSteps } from "../../wizard/wizardSteps";
import type { PortalSourcingEventDetailDto } from "../../../autogen/bff-api";

// Stage 1 of a two-stage procedure: a forespørsel om å delta carries the ESPD and the
// qualification answers — no price, no offer documents, no signing (those belong to stage 2).
export const REQUEST_WIZARD_STEPS = [
  { key: "intro", icon: FaInfoCircle },
  { key: "supplier", icon: FaUserTie },
  { key: "exclusion", icon: FaUserCheck },
  { key: "qualification", icon: FaTasks },
  { key: "review", icon: FaPaperPlane },
] as const satisfies ReadonlyArray<{ key: string; icon: IconType }>;

export type RequestStep = (typeof REQUEST_WIZARD_STEPS)[number]["key"];

export interface RequestStepVisibility {
  asksForEspd: boolean;
}

export const requestStepVisibility = (event: PortalSourcingEventDetailDto): RequestStepVisibility => ({
  asksForEspd: event.asksForEspd ?? true,
});

const isStepVisible = (key: RequestStep, v: RequestStepVisibility): boolean =>
  key === "supplier" || key === "exclusion" ? v.asksForEspd : true;

export const requestWizardModel = defineWizardSteps<RequestStep, RequestStepVisibility>(
  REQUEST_WIZARD_STEPS,
  isStepVisible,
);
